(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8512],{

/***/ 52732:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lcv-booking/[routeSlug]",
      function () {
        return __webpack_require__(7065);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ LcvRouteBookingPage; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/layout/plain-layout/PlainLayout.tsx
var PlainLayout = __webpack_require__(23441);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ../core/dist/constants/platformStats.js
var platformStats = __webpack_require__(28230);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ../core/dist/icons/VahakLogoBlue_n.svg
var VahakLogoBlue_n = __webpack_require__(70621);
// EXTERNAL MODULE: ../core/dist/icons/VahakLogoWhite_n.svg
var VahakLogoWhite_n = __webpack_require__(19814);
// EXTERNAL MODULE: ./components/common/page-meta-tags/PageMetaTags.tsx
var PageMetaTags = __webpack_require__(96696);
// EXTERNAL MODULE: ./components/homepage-v2/compact-load-posting/CompactLoadPostingProvider.tsx + 1 modules
var CompactLoadPostingProvider = __webpack_require__(56193);
// EXTERNAL MODULE: ./methods/pageSeo.ts + 1 modules
var pageSeo = __webpack_require__(61706);
// EXTERNAL MODULE: ./components/lcv-route-landing/LcvRouteIcon.tsx
var LcvRouteIcon = __webpack_require__(3749);
// EXTERNAL MODULE: ./components/lcv-route-landing/lcvRouteLanding.constants.ts
var lcvRouteLanding_constants = __webpack_require__(11529);
// EXTERNAL MODULE: ./components/lcv-route-landing/LcvRouteLandingPage.module.scss
var LcvRouteLandingPage_module = __webpack_require__(48336);
var LcvRouteLandingPage_module_default = /*#__PURE__*/__webpack_require__.n(LcvRouteLandingPage_module);
// EXTERNAL MODULE: ./components/lcv-route-landing/useLcvRouteLandingTranslation.ts
var useLcvRouteLandingTranslation = __webpack_require__(70812);
;// CONCATENATED MODULE: ./components/lcv-route-landing/LcvRouteLandingPage.tsx
















var RouteLink = function(param) {
    var href = param.href, className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: className,
            children: children
        })
    });
};
var Header = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: (LcvRouteLandingPage_module_default())["site-header"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RouteLink, {
            href: "/",
            className: (LcvRouteLandingPage_module_default())["logo-link"],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VahakLogoBlue_n/* default */.Z, {
                className: (LcvRouteLandingPage_module_default())["logo-svg"],
                "aria-label": "Vahak"
            })
        })
    });
};
var Hero = function(param) {
    var routeContent = param.routeContent, formRef = param.formRef, heroCtaRef = param.heroCtaRef, onBookLorryNow = param.onBookLorryNow, isCompactPostingOpen = param.isCompactPostingOpen, eyebrow = param.eyebrow, headline1 = param.headline1, ctaLabel = param.ctaLabel, priceEstimatePrompt = param.priceEstimatePrompt, priceEstimateLink = param.priceEstimateLink, pickupAriaLabel = param.pickupAriaLabel, dropAriaLabel = param.dropAriaLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (LcvRouteLandingPage_module_default()).hero,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LcvRouteLandingPage_module_default())["hero-copy"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (LcvRouteLandingPage_module_default())["eyebrow-kw"],
                        children: eyebrow
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: (LcvRouteLandingPage_module_default())["hero-h1"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (LcvRouteLandingPage_module_default())["headline-1"],
                                children: headline1
                            }),
                            routeContent.heroHeadline2Lines.map(function(line) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (LcvRouteLandingPage_module_default())["headline-2"],
                                    children: line
                                }, line);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (LcvRouteLandingPage_module_default())["hero-sub"],
                        children: routeContent.heroSub
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LcvRouteLandingPage_module_default())["hero-form-card"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    className: (LcvRouteLandingPage_module_default())["load-form"],
                    id: "load-form",
                    ref: formRef,
                    onSubmit: function(event) {
                        event.preventDefault();
                        onBookLorryNow();
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (LcvRouteLandingPage_module_default()).field,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LcvRouteIcon/* default */.Z, {
                                    iconClassName: "ti ti-map-pin"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    name: "pickup",
                                    id: "pickup",
                                    defaultValue: routeContent.pickupCity,
                                    "aria-label": pickupAriaLabel,
                                    readOnly: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (LcvRouteLandingPage_module_default()).field,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LcvRouteIcon/* default */.Z, {
                                    iconClassName: "ti ti-navigation"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    name: "drop",
                                    id: "drop",
                                    defaultValue: routeContent.dropCity,
                                    "aria-label": dropAriaLabel,
                                    readOnly: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (LcvRouteLandingPage_module_default())["hero-actions"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "submit",
                                    className: (LcvRouteLandingPage_module_default())["btn-primary"],
                                    id: "hero-cta-btn",
                                    ref: heroCtaRef,
                                    disabled: isCompactPostingOpen,
                                    children: ctaLabel
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: (LcvRouteLandingPage_module_default())["price-link"],
                                    children: [
                                        priceEstimatePrompt,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "#",
                                            onClick: function(event) {
                                                event.preventDefault();
                                                if (isCompactPostingOpen) {
                                                    return;
                                                }
                                                onBookLorryNow();
                                            },
                                            "aria-disabled": isCompactPostingOpen,
                                            children: priceEstimateLink
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var TrustStrip = function(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (LcvRouteLandingPage_module_default())["trust-strip"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LcvRouteIcon/* default */.Z, {
                iconClassName: "ti ti-shield-check"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: text
            })
        ]
    });
};
var HowItWorks = function(param) {
    var title = param.title, steps = param.steps;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (LcvRouteLandingPage_module_default())["steps-block"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (LcvRouteLandingPage_module_default())["steps-title"],
                children: title
            }),
            steps.map(function(text, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (LcvRouteLandingPage_module_default())["step-row"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (LcvRouteLandingPage_module_default())["step-num"],
                            children: index + 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (LcvRouteLandingPage_module_default())["step-text"],
                            children: text
                        })
                    ]
                }, text);
            })
        ]
    });
};
var AboutBlock = function(param) {
    var title = param.title, aboutText = param.aboutText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (LcvRouteLandingPage_module_default())["about-block"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (LcvRouteLandingPage_module_default())["about-title"],
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (LcvRouteLandingPage_module_default())["about-text"],
                children: aboutText
            })
        ]
    });
};
var ProofModule = function(param) {
    var proofLabel = param.proofLabel, stats = param.stats, features = param.features;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LcvRouteLandingPage_module_default())["proof-card"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (LcvRouteLandingPage_module_default())["proof-label"],
                        children: proofLabel
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (LcvRouteLandingPage_module_default())["stat-grid"],
                        children: stats.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (LcvRouteLandingPage_module_default())["stat-cell"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (LcvRouteLandingPage_module_default())["stat-num"],
                                        children: item.value
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (LcvRouteLandingPage_module_default())["stat-label"],
                                        children: item.label
                                    })
                                ]
                            }, item.label);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LcvRouteLandingPage_module_default())["feature-row"],
                children: features.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (LcvRouteLandingPage_module_default())["feature-item"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LcvRouteIcon/* default */.Z, {
                                iconClassName: item.iconClassName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: item.label
                            })
                        ]
                    }, item.label);
                })
            })
        ]
    });
};
var ChipBlock = function(param) {
    var label = param.label, chips = param.chips;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (LcvRouteLandingPage_module_default())["chip-block"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (LcvRouteLandingPage_module_default())["chip-label"],
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LcvRouteLandingPage_module_default())["chip-row"],
                children: chips.map(function(chip) {
                    return chip.href ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RouteLink, {
                        className: (LcvRouteLandingPage_module_default()).chip,
                        href: chip.href,
                        children: chip.label
                    }, chip.label) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (LcvRouteLandingPage_module_default()).chip,
                        children: chip.label
                    }, chip.label);
                })
            })
        ]
    });
};
var SeoContent = function(param) {
    var routeContent = param.routeContent, faqTitle = param.faqTitle, popularRoutesLabel = param.popularRoutesLabel, vehicleTypesLabel = param.vehicleTypesLabel, allLcvRoutesLabel = param.allLcvRoutesLabel, allLcvRouteChips = param.allLcvRouteChips;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LcvRouteLandingPage_module_default())["faq-block"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (LcvRouteLandingPage_module_default())["block-title"],
                        children: faqTitle
                    }),
                    routeContent.faqs.map(function(faq) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("details", {
                            className: (LcvRouteLandingPage_module_default())["faq-item"],
                            open: faq.defaultOpen,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("summary", {
                                    children: faq.question
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (LcvRouteLandingPage_module_default())["faq-answer"],
                                    children: faq.answer
                                })
                            ]
                        }, faq.question);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipBlock, {
                label: allLcvRoutesLabel,
                chips: allLcvRouteChips
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipBlock, {
                label: popularRoutesLabel,
                chips: routeContent.popularRoutes
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipBlock, {
                label: vehicleTypesLabel,
                chips: routeContent.vehicleTypes
            })
        ]
    });
};
var FooterGroup = function(param) {
    var group = param.group;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (LcvRouteLandingPage_module_default())["footer-group"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (LcvRouteLandingPage_module_default())["fg-label"],
                children: group.label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LcvRouteLandingPage_module_default())["fg-links"],
                children: [
                    (ref = group.links) === null || ref === void 0 ? void 0 : ref.map(function(link) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RouteLink, {
                            href: link.href,
                            children: link.label
                        }, link.href);
                    }),
                    (ref1 = group.textItems) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (LcvRouteLandingPage_module_default())["fg-text"],
                            children: item
                        }, item);
                    }),
                    group.moreLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RouteLink, {
                        className: (LcvRouteLandingPage_module_default())["fg-more"],
                        href: group.moreLink.href,
                        children: group.moreLink.label
                    }) : null
                ]
            })
        ]
    });
};
var Footer = function(param) {
    var footerSeoText = param.footerSeoText, brandText = param.brandText, groups = param.groups, playStoreLabel = param.playStoreLabel, copyright = param.copyright, madeInIndia = param.madeInIndia;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (LcvRouteLandingPage_module_default())["site-footer"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LcvRouteLandingPage_module_default())["footer-seo-text"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: footerSeoText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LcvRouteLandingPage_module_default())["wrap-footer"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (LcvRouteLandingPage_module_default())["footer-brand"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LcvRouteLandingPage_module_default())["logo-row"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RouteLink, {
                                    href: "/",
                                    className: (LcvRouteLandingPage_module_default())["logo-link"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VahakLogoWhite_n/* default */.Z, {
                                        className: (LcvRouteLandingPage_module_default())["footer-logo-svg"],
                                        "aria-label": "Vahak"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: brandText
                            })
                        ]
                    }),
                    groups.map(function(group) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterGroup, {
                            group: group
                        }, group.label);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LcvRouteLandingPage_module_default())["footer-social"],
                children: lcvRouteLanding_constants/* LCV_ROUTE_SOCIAL_LINKS.map */.te.map(function(socialLink) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: socialLink.href,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "aria-label": socialLink.label,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LcvRouteIcon/* default */.Z, {
                            iconClassName: socialLink.iconClassName
                        })
                    }, socialLink.href);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LcvRouteLandingPage_module_default())["footer-app"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: lcvRouteLanding_constants/* LCV_ROUTE_PLAY_STORE_URL */.rp,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LcvRouteIcon/* default */.Z, {
                            iconClassName: "ti ti-brand-google-play"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: playStoreLabel
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LcvRouteLandingPage_module_default())["footer-bottom"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: copyright
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (LcvRouteLandingPage_module_default())["footer-made"],
                        children: madeInIndia
                    })
                ]
            })
        ]
    });
};
var StickyCta = function(param) {
    var isVisible = param.isVisible, onClick = param.onClick, isCompactPostingOpen = param.isCompactPostingOpen, ctaLabel = param.ctaLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((LcvRouteLandingPage_module_default())["sticky-cta"], isVisible && (LcvRouteLandingPage_module_default())["is-visible"]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            type: "button",
            className: (LcvRouteLandingPage_module_default())["btn-primary"],
            onClick: onClick,
            disabled: isCompactPostingOpen,
            children: ctaLabel
        })
    });
};
var LcvRouteLandingPage = function(param) {
    var routeConfig = param.routeConfig;
    var t = (0,useLcvRouteLandingTranslation/* default */.Z)().t;
    var ref = (0,router.useRouter)(), _locale = ref.locale, locale = _locale === void 0 ? "en" : _locale;
    var compactPosting = (0,CompactLoadPostingProvider/* useCompactLoadPostingOptional */.qA)();
    var formRef = (0,react.useRef)(null);
    var heroCtaRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), isStickyCtaVisible = ref1[0], setIsStickyCtaVisible = ref1[1];
    var isCompactPostingOpen = Boolean(compactPosting === null || compactPosting === void 0 ? void 0 : compactPosting.isCompactPostingOpen);
    var routeContent = t("routes.".concat(routeConfig.slug), {
        returnObjects: true
    });
    var howItWorksSteps = t("howItWorks.steps", {
        returnObjects: true
    });
    var proofStats = t("proof.stats", {
        returnObjects: true
    });
    var features = t("features", {
        returnObjects: true
    });
    var footerGroups = t("footer.groups", {
        returnObjects: true
    });
    var lcvRouteLabels = t("footer.lcvRouteLabels", {
        returnObjects: true
    });
    var allLcvRouteChips = lcvRouteLanding_constants/* LCV_BOOKING_ROUTE_SLUGS.map */.C1.map(function(slug) {
        return {
            label: lcvRouteLabels[slug],
            href: (0,lcvRouteLanding_constants/* getLcvBookingRoutePath */.Yv)(slug)
        };
    });
    var faqList = routeContent.faqs.map(function(faq) {
        return {
            question: faq.question,
            answer: faq.answer
        };
    });
    var isKannada = locale === "kn";
    var isHindi = locale === "hi" || locale === "mr";
    var isTelugu = locale === "te";
    var handleBookLorryNow = (0,react.useCallback)(function() {
        compactPosting === null || compactPosting === void 0 ? void 0 : compactPosting.openCompactPosting({
            source: routeConfig.source,
            destination: routeConfig.destination
        }, {
            eventData: {
                source_screen: event_names/* WEB_V2_SOURCE_SCREENS.LCV_ROUTE_LANDING */.ZM.LCV_ROUTE_LANDING
            }
        });
    }, [
        compactPosting,
        routeConfig.destination,
        routeConfig.source
    ]);
    (0,react.useEffect)(function() {
        var heroBtn = heroCtaRef.current;
        if (!heroBtn || typeof IntersectionObserver === "undefined") {
            return;
        }
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                setIsStickyCtaVisible(!entry.isIntersecting);
            });
        }, {
            threshold: 0
        });
        observer.observe(heroBtn);
        return function() {
            observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMetaTags/* default */.Z, {
                title: routeContent.seo.title,
                description: routeContent.seo.description,
                locale: locale,
                localeNeutralPath: (0,lcvRouteLanding_constants/* getLcvBookingRoutePath */.Yv)(routeConfig.slug),
                ogType: "website",
                ogSiteName: "Vahak",
                ogImgAltText: routeContent.seo.title,
                includeDefaultSchema: true,
                schema: {
                    breadcrumbItems: [
                        {
                            name: t("meta.breadcrumbHome"),
                            url: (0,pageSeo/* getHomeUrl */.cd)()
                        },
                        {
                            name: t("meta.breadcrumbLcvBooking"),
                            path: "/lcv-booking"
                        },
                        {
                            name: routeContent.breadcrumbRouteName
                        }
                    ],
                    faqList: faqList
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: classnames_default()((LcvRouteLandingPage_module_default()).page, isKannada && (LcvRouteLandingPage_module_default()).pageKn, isHindi && (LcvRouteLandingPage_module_default()).pageHi, isTelugu && (LcvRouteLandingPage_module_default()).pageTe),
                lang: locale,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {
                        routeContent: routeContent,
                        formRef: formRef,
                        heroCtaRef: heroCtaRef,
                        onBookLorryNow: handleBookLorryNow,
                        isCompactPostingOpen: isCompactPostingOpen,
                        eyebrow: t("hero.eyebrow"),
                        headline1: t("hero.headline1"),
                        ctaLabel: t("hero.cta"),
                        priceEstimatePrompt: t("hero.priceEstimatePrompt"),
                        priceEstimateLink: t("hero.priceEstimateLink"),
                        pickupAriaLabel: t("hero.pickupAriaLabel"),
                        dropAriaLabel: t("hero.dropAriaLabel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustStrip, {
                        text: t("trustStrip", (0,platformStats/* getPlatformStatI18nLabels */.E)())
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorks, {
                        title: t("howItWorks.title"),
                        steps: howItWorksSteps
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutBlock, {
                        title: t("about.title"),
                        aboutText: routeContent.aboutText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProofModule, {
                        proofLabel: t("proof.label"),
                        stats: proofStats,
                        features: features
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoContent, {
                        routeContent: routeContent,
                        faqTitle: t("faq.title"),
                        popularRoutesLabel: t("chips.popularRoutes"),
                        vehicleTypesLabel: t("chips.vehicleTypes"),
                        allLcvRoutesLabel: t("chips.allLcvRoutes"),
                        allLcvRouteChips: allLcvRouteChips
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        footerSeoText: routeContent.footerSeoText,
                        brandText: t("footer.brandText"),
                        groups: footerGroups,
                        playStoreLabel: t("footer.playStore"),
                        copyright: t("footer.copyright"),
                        madeInIndia: t("footer.madeInIndia")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyCta, {
                        isVisible: isStickyCtaVisible,
                        onClick: handleBookLorryNow,
                        isCompactPostingOpen: isCompactPostingOpen,
                        ctaLabel: t("hero.cta")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var lcv_route_landing_LcvRouteLandingPage = (LcvRouteLandingPage);

;// CONCATENATED MODULE: ./pages/lcv-booking/[routeSlug].tsx




var __N_SSG = true;
function LcvRouteBookingPage(param) {
    var routeConfig = param.routeConfig;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lcv_route_landing_LcvRouteLandingPage, {
        routeConfig: routeConfig
    });
};
LcvRouteBookingPage.getLayout = function(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainLayout/* PlainLayout */.o, {
        page: page
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8116,9774,2888,179], function() { return __webpack_exec__(52732); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);